import { z } from "zod";

import { ExperienceDtoSchema } from "../../../../dtos/experiences";
import { PluginOfferProductSchema_2024_05_05 } from "../offers/offerProducts/2024-05-05";

export const PluginExperienceSchema_2024_05_05 = ExperienceDtoSchema.omit({
  variations: true,
  experienceAnalysis: true,
  isDeleted: true,
  userInterfaces: true,
}).extend({
  offerProducts: PluginOfferProductSchema_2024_05_05.array(),
});
export type PluginExperienceType_2024_05_05 = z.infer<
  typeof PluginExperienceSchema_2024_05_05
>;
